import clsx from 'clsx';
import * as React from 'react';
import { CSSProperties, ReactNode } from 'react';

import styles from './PillButton.module.scss';

export enum PillColor {
  Grey = 'grey',
  Green = 'green',
  Red = 'red',
  Yellow = 'yellow',
  Blue = 'blue',
  Purple = 'purple',
  Accent = 'accent',
}

export type PillButtonProps = {
  id?: string;
  type?: 'submit' | 'button';
  title: ReactNode;
  color?: PillColor;
  /**
   * `undefined` renders a plain colored pill without a selection state,
   * a boolean turns the pill into a switchable one.
   */
  selected?: boolean;
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
  testId?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export const PillButton = React.forwardRef<HTMLButtonElement, PillButtonProps>(
  function PillButton(props, ref) {
    const {
      id,
      type = 'button',
      title,
      color = PillColor.Grey,
      selected,
      disabled,
      className,
      style,
      testId,
      onClick,
    } = props;

    const isSelectable = selected !== undefined;

    return (
      <button
        id={id}
        ref={ref}
        type={type}
        style={style}
        disabled={disabled}
        data-disabled={disabled}
        data-test-id={testId}
        aria-pressed={isSelectable ? selected : undefined}
        onClick={onClick}
        className={clsx(
          styles.pill,
          styles[color],
          {
            [styles.unselected]: isSelectable && !selected,
            [styles.disabled]: disabled,
          },
          className,
        )}
      >
        {title}
      </button>
    );
  },
);
